// ------------------------------------
// Constants
// ------------------------------------
export const LOCATION_CHANGE = 'LOCATION_CHANGE';
export const CALL_HISTORY_METHOD = 'CALL_HISTORY_METHOD';

// ------------------------------------
// Actions
// ------------------------------------
export function locationChange(location = '/') {
  return {
    type: LOCATION_CHANGE,
    payload: location
  };
}

export function callHistoryMethod(method, args) {
  history.push(location);
  return {
    type: CALL_HISTORY_METHOD,
    payload: { method, args }
  };
}

// ------------------------------------
// Specialized Action Creator
// ------------------------------------
export const updateLocation = ({ dispatch }) => nextLocation => dispatch(locationChange(nextLocation));

export const callHistoryMethodCreator = ({ dispatch }) => (method, args) => dispatch(callHistoryMethod(method, args));

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = null;
export default function locationReducer(state = initialState, action) {
  return action.type === LOCATION_CHANGE
    ? action.payload
    : state;
}
